export * from '@app/advisor-v5-shared';
//# sourceMappingURL=_shared.js.map